<template>
  <div class="veda-product">
    <div class="web-box top">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div style="max-width:500px;margin:0 auto">
            <h2>VEDA Marketing API</h2>
            <p>Open API 自动化营销工具</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img
            class="top-img"
            src="http://www.vedamobi.com/assets/website/images/api/top.png"
          />
        </a-col>
      </a-row>
    </div>
    <div class="label-wrap">
      <h4>VEDA Marketing API</h4>
      <div></div>
      <p>零基础快速获取资源</p>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <img
            class="left"
            src="http://www.vedamobi.com/assets/website/images/api/content1.png"
          />
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap right">
            <p class="text">
              全面开放接口及技术服务
              <br />- 提供广告主批量创建、订单批量创建等接口 <br />-
              快速接入自有网站 <br />- 低门槛，节省服务器和开发人力成本
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap left">
            <p class="text">
              轻松搭建媒体矩阵
              <br />- 多类优质媒体自选，满足不同诉求 <br />-
              全链路场景媒体，满足品效诉求 <br />- 支持线上视频培训教程
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img
            class="right"
            src="http://www.vedamobi.com/assets/website/images/api/content2.png"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import ScrollReveal from 'scrollreveal'
export default {
  data () {
    return {
      scrollReveal: ScrollReveal()
    }
  },

  mounted () {
    this.scrollReveal.reveal(`.left`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'left',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
    this.scrollReveal.reveal(`.right`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'right',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
  },
  methods: {
    goCallUs () {
      const btn = document.getElementById('callusForm')
      const scrollHeight = btn.offsetTop
      window.scrollTo(0, scrollHeight)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/product_page.scss';
</style>
